/**
 * Serializes async work onto a single in-order chain. Used to guard
 * localStorage read-modify-write races on session updates: two concurrent
 * multi-QR responses must not stomp on each other's writes.
 *
 * Each enqueued task waits for the prior one to settle (success OR failure)
 * — one task's exception never sinks the rest of the queue.
 */
export class WriteQueue {
  private tail: Promise<unknown> = Promise.resolve();

  enqueue<T>(task: () => Promise<T> | T): Promise<T> {
    const run = this.tail.catch(() => undefined).then(() => task());
    this.tail = run;
    return run;
  }
}
